// extracted by mini-css-extract-plugin
module.exports = {"aside":"l_w","list":"l_x","listItem":"l_y"};